module.exports = __webpack_public_path__ + "img/RhythmicVillageLogo.de0b3d78.png";